import { muiStyles } from 'utils/design';

export const useStyles = muiStyles(() => ({
  toolbar: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
}));
